import { constants } from '../config';

export const initMemory = (lineId) => ({ type: constants.INIT_MEMORY, lineId });
export const initMemorySuccess = (data) => ({ type: constants.INIT_MEMORY_SUCCESS, payload: data });
export const initMemoryFail = (error) => ({ type: constants.INIT_MEMORY_FAIL, error });

export const getMemory = (lineId, memoryUuid) => ({ type: constants.GET_MEMORY, lineId, memoryUuid });
export const getMemorySuccess = (data, lineId) => ({ type: constants.GET_MEMORY_SUCCESS, payload: data, lineId });
export const getMemoryFail = (error) => ({ type: constants.GET_MEMORY_FAIL, error });

export const saveBlock = (lineId, blockKey, answers, memoryUuid) => ({
  type: constants.SAVE_BLOCK,
  lineId,
  blockKey,
  answers,
  memoryUuid,
});
export const saveBlockSuccess = (data) => ({ type: constants.SAVE_BLOCK_SUCCESS, payload: data });
export const saveBlockFail = (error) => ({ type: constants.SAVE_BLOCK_FAIL, error });

export const generateMemory = (lineId, memoryUuid) => ({ type: constants.GENERATE_MEMORY, lineId, memoryUuid });
export const generateMemorySuccess = (data) => ({
  type: constants.GENERATE_MEMORY_SUCCESS,
  payload: data,
});
export const generateMemoryFail = (error) => ({ type: constants.GENERATE_MEMORY_FAIL, error });

export const pollStatus = (lineId, memoryUuid) => ({ type: constants.POLL_STATUS, lineId, memoryUuid });
export const pollStatusSuccess = (data) => ({ type: constants.POLL_STATUS_SUCCESS, payload: data });
export const pollStatusFail = (error) => ({ type: constants.POLL_STATUS_FAIL, error });

export const setCurrentBlock = (blockKey) => ({ type: constants.SET_CURRENT_BLOCK, blockKey });
export const resetEditor = () => ({ type: constants.RESET });
